import { apiClient } from "../api/apiClient";

import {
  ApiResponse,
  Material,
  CreateMaterialRequest
} from "../interfaces/Material";

// ======================================
// MATERIAL SERVICE
// ======================================
type ResponseDto<T> = {

  loggingHistoryID?: number;

  statusCode: number;

  isSuccess: boolean;

  message: string;

  errors?: string[];

  data?: T;

  dataList?: T[];
};
export const materialService = {

  // ======================================
  // GET ALL
  // ======================================

getAll: async (): Promise<Material[]> => {
  const response = await apiClient.get<ApiResponse<Material>>("/Material");

  const result = response.data;

  if (!result.isSuccess) {
    throw new Error(result.message);
  }   

  return result.dataList ?? [];
},

  // ======================================
  // GET BY ID
  // ======================================

  // getById: async (
  //   id: number
  // ): Promise<Material> => {

  //   const response =
  //     await apiClient.get<
  //       ApiResponse<Material>
  //     >(
  //       `/Material/${id}`
  //     );

  //   const result = response.data;

  //   if (!result.isSuccess) {

  //     throw new Error(
  //       result.message
  //     );
  //   }

  //   return result.data;
  // },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateMaterialRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "MaterialName",
      payload.materialName
    );

    formData.append(
      "MaterialSlug",
      payload.materialSlug
    );

    formData.append(
      "Description",
      payload.description || ""
    );

    formData.append(
      "MaterialTypeID",
      payload.materialTypeID?.toString() || ""
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    // IMAGE

    if (payload.ogImage) {

      formData.append(
        "OgImage",
        payload.ogImage
      );
    }

    const response =
      await apiClient.post(
        "/Material/Create",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: CreateMaterialRequest & {
      materialID: number;
    }
  ) => {

    const formData =
      new FormData();

    formData.append(
      "MaterialID",
      payload.materialID.toString()
    );

    formData.append(
      "MaterialName",
      payload.materialName
    );

    formData.append(
      "MaterialSlug",
      payload.materialSlug
    );

    formData.append(
      "Description",
      payload.description || ""
    );

    formData.append(
      "MaterialTypeID",
      payload.materialTypeID?.toString() || ""
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    // IMAGE

    if (payload.ogImage) {

      formData.append(
        "OgImage",
        payload.ogImage
      );
    }

    const response =
      await apiClient.put(
        "/Material",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/Material/${id}`
      );

    return response.data;
  },
 formatDateTime(dateInput: string | Date) {
    if (!dateInput) return "-";

    const date = new Date(dateInput);

    const pad = (n: number) => n.toString().padStart(2, "0");

    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    const formattedHours = pad(hours);

    return `${month}/${day}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }




  
}; 